import React, { useContext } from 'react'
import { PropertyMainImage } from './PropertyMainImage'
import { PropertyDetails } from './PropertyDetails'
import { PropertyTitle } from './PropertyTitle'
import { Context } from '../../../Store'
import { isEmpty } from 'lodash'
import { Grid } from '@material-ui/core'

export const PropertyDetailCard = () => {
  const [state] = useContext(Context)
  if (isEmpty(state.property)) {
    return null
  }

  return (
    <Grid container lg={12} md={12} sm={12} xs={12}
      style={{
        gap: '24px',
        padding: '12px',
        borderRadius: '0.5rem',
        backgroundColor: '#fff',
        boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.10)',
      }}>
      <Grid item lg={3} md={3} sm={3} xs={3}>
        <PropertyMainImage propertyImage={state.property.images[0].url} />
      </Grid>
      <Grid item lg={9} md={9} sm={9} xs={9} style={{ flex: 1, minWidth: 0 }}>
        <PropertyTitle />
        {/* <PropertyDetails noIcons /> */}
      </Grid>
    </Grid>
  )
}
